// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__a_iec","cell":"ColumnAccessor_cell__O-kXo","firstCellAccent":"ColumnAccessor_firstCellAccent__3uYXz"};